module["exports"] = ["Dr.", "Prof.", "PhD."];